@if(loading$ | async) {
<app-loading class="h-100 w-100 loading-container" [text]="'Loading'"></app-loading>
} @else {
  <div class="button-list">
    <button class="release-btn btn-accello-secondary" (click)="addNewPage()">
      <img
        [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
        alt="Add Icon"
        width="18"
        height="18"
      />
      Add New Page
    </button>

    <button
      class="release-btn btn-accello-light"
      (click)="removePages()"
      [disabled]="!selectedPages.length"
      (focus)="changeRemoveIcon(false)"
      (mouseenter)="changeRemoveIcon(false)"
      (mouseleave)="changeRemoveIcon(false)"
      (blur)="changeRemoveIcon(false)"
      (mousedown)="changeRemoveIcon(true)"
      (mouseup)="changeRemoveIcon(false)"
    >
      <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
      <span>Remove Pages</span>
      @if(isLoading){
        <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
      }
    </button>
    <button class="btn-accello-ternary" (click)="refreshData()">
      <img src="assets/images/virtusa-icons/sync.svg" alt="refresh" />
      <span>Refresh</span>
    </button>
  </div>
  <div class="d-flex flex-row">
    <div class="page-tab d-flex gap-3">
      <div class="name-div"><span class="accello-general-text2 pg-sp">Application Name</span>
        <span class="accello-general-text13">{{
          app?.name
        }}</span></div>
    </div>
  </div>
<div class="table-wrapper">
  <app-zorro-table
  tableId="apps-tabular"
  class="applications"
  [data]="dataSource"
  [columns]="columns"
  [options]="options"
  (handleActions)="handleActionsInTable($event)"
  (onRowSelect)="handleRowSelect($event)"
></app-zorro-table>
</div>
}
